// jQuery plugins
import './globals/jquery';
import './globals/jquery-plugins';
import 'jquery-trend'; // eslint-disable-line
import 'jquery-revealer'; // eslint-disable-line
import 'array-includes'; // eslint-disable-line
import 'jquery-nice-select';

// Responsive Images
import 'intersection-observer'; // eslint-disable-line
import rimg from 'rimg-shopify'; // eslint-disable-line

// Helpers
import ObjectFitPolyfill from './helpers/ObjectFitPolyfill';
import './helpers/formElements';

// Template imports
import Page from './templates/Page';
import SearchPage from './templates/SearchPage';
import Account from './templates/Account';
import Subscription from './templates/Subscription';
import AllReviews from './templates/AllReviews';

// Section imports
import Sections from './Sections';
import StaticStorySlideshow from './sections/StaticStorySlideshow';
import FeaturedProducts from './sections/FeaturedProducts';
import ImageWithTextOverlay from './sections/ImageWithTextOverlay';
import StaticCart from './sections/StaticCart';
import StaticGiftCard from './sections/StaticGiftCard';
import StaticHeader from './sections/StaticHeader';
import StaticFooter from './sections/StaticFooter';
import StaticProductPages from './sections/StaticProductPages';
import StaticStory from './sections/StaticStory';
import VideoWithText from './sections/VideoWithText';

// Component imports
import { BannerManager } from './components/BannerManager';
import AccountExpand from './components/AccountExpand';
import {
  readmoreHandler,
  initSlider,
  freshChatTrigger,
  smileTrigger
}
from './components/utilHandlers';

const data = JSON.parse(document.body.querySelector('[data-theme-data]').innerHTML);

new BannerManager({
  target: document.body.querySelector('[data-banners]'),
  dismissIcon: data.dismiss_icon,
});

new AccountExpand(document.querySelector('[data-expandable-container]'));

rimg.init();
readmoreHandler();
initSlider();
freshChatTrigger();
smileTrigger();
$('[data-nice-select]').niceSelect();

const sections = new Sections();
sections.register('dynamic-image-with-text-overlay', section => new ImageWithTextOverlay(section));
sections.register('dynamic-video-with-text', section => new VideoWithText(section));
sections.register('static-cart', section => new StaticCart(section));
sections.register('static-collection-pages', section => new StaticCollectionPages(section));
sections.register('static-gift-card', section => new StaticGiftCard(section));
sections.register('static-header', section => new StaticHeader(section));
sections.register('static-product-pages', section => new StaticProductPages(section));
sections.register('static-story-slideshow', section => new StaticStorySlideshow(section));
sections.register('static-related-products', section => new FeaturedProducts(section));
sections.register('static-story', section => new StaticStory(section));

new SearchPage();
new Page();
new ObjectFitPolyfill();
new Subscription();
new AllReviews();

const account = new Account();
account.initAddresses()
  .catch(error => console.error(error));

new StaticFooter();
